import { Button, Card, styled, Typography } from "~/common/mui";
import { Trans, useTranslation } from "react-i18next";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { type PriceData } from "~/domains/pricing/types/PriceData";
import { Snackbar } from "~/common/mui/Snackbar/Snackbar";
import { formatCurrency } from "~/common/utils/currencyFormatter";

export interface ATCBarProps {
  selectedLineItems: number;
  selectedQuantity: number;
  totalPrice: PriceData;
  loading?: boolean;
  onAddToCart: () => void;
}

export const ATCBar = ({ selectedLineItems, selectedQuantity, totalPrice, loading, onAddToCart }: ATCBarProps) => {
  const { t } = useTranslation();

  return (
    <Snackbar open={true}>
      <AtcCard>
        <Typography color="text.secondary" fontWeight={"medium"} variant="titleMedium">
          <Trans i18nKey={"feature.order.atcBar.selected"} count={selectedLineItems}>
            <Typography variant="titleMedium" component={"b"} color="primaryContainer.contrastText">
              {{ count: selectedLineItems }}
            </Typography>
            Selected line
          </Trans>
        </Typography>
        <Typography color="text.secondary" fontWeight={"medium"} variant="titleMedium">
          <Trans i18nKey={"feature.order.atcBar.quantity"} count={selectedQuantity}>
            <Typography variant="titleMedium" component={"b"} color="primaryContainer.contrastText">
              {{ count: selectedQuantity }}
            </Typography>
            Pcs.
          </Trans>
        </Typography>
        <Typography variant="titleMedium" component={"b"} color="primaryContainer.contrastText">
          {formatCurrency(totalPrice?.value, totalPrice?.currencyIso)}
        </Typography>
        <Button
          data-test-id={"add-all-to-cart"}
          startIcon={<ShoppingCartOutlinedIcon />}
          loading={loading}
          onClick={onAddToCart}
        >
          {t("orderQuotePage.ATCBar.btn")}
        </Button>
      </AtcCard>
    </Snackbar>
  );
};

const AtcCard = styled(Card)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: ` ${theme.spacing(1.5)} ${theme.spacing(2)}`,
  gap: `${theme.spacing(3)}`,
  borderRadius: "100px",
  border: 0,
  boxShadow: theme.shadows[1],
  background: theme.palette.primaryContainer.main,
}));
